import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { Link } from "react-router-dom";
import getTranslation from "../../TranslationUtility/TranslationUtility";
import { ApiConfigData } from "../../Utility/Utility";
import ArrowDownFooter from "../../Assets/imgNewUI/Arrow_Down_Footer.svg";
import ArrowUpFooter from "../../Assets/imgNewUI/Arrow_Up_Footer.svg";


const Footer = ({ isMobileView, sectionMasterData, sctionContentdata }) => {
  const url = window.location.pathname;
  const apiConfigData = ApiConfigData();
  const footerContentRef = useRef(null);
  const [isExpanded, setIsExpanded] = useState(false);
  const [showReadMore, setShowReadMore] = useState(false);
  const [contentHeight, setContentHeight] = useState({ collapsed: 0, expanded: 0 });

  const sectionFilter = sectionMasterData?.find(
    (findData) => findData?.sectionType === "Footer"
  );
  const translation = getTranslation();

  const footerSection = apiConfigData?.find(
    (data) => data?.paramsKey === "FooterSection"
  )?.paramsValue;

  let footerSectionData = {};
  
  try {
    if (typeof footerSection === "string") {
      footerSectionData = JSON.parse(footerSection);
    } else if (typeof footerSection === "object" && footerSection !== null) {
      footerSectionData = footerSection;
    }
  } catch (err) {
    console.error("❌ JSON parse error:", err, footerSection);
    footerSectionData = {};
  }
  const lineLimit = useMemo(
    () =>
      isMobileView
        ? footerSectionData?.MobileReadMoreLines || 3
        : footerSectionData?.WebReadMoreLines || 1,
    [isMobileView]
  );

  const measureFooterContent = useCallback(() => {
    const element = footerContentRef.current;
    if (!element) {
      return;
    }

    const computedStyle = window.getComputedStyle(element);
    const lineHeight = parseFloat(computedStyle.lineHeight) || 16;
    const collapsedHeight = Math.ceil(lineHeight * lineLimit);
    const expandedHeight = element.scrollHeight;
    const hasOverflow = expandedHeight - collapsedHeight > 1;

    setShowReadMore(hasOverflow);
    setContentHeight({
      collapsed: hasOverflow ? collapsedHeight : expandedHeight,
      expanded: expandedHeight,
    });
  }, [lineLimit]);

  useEffect(() => {
    const timer = setTimeout(() => {
      measureFooterContent();
    }, 0);

    const handleResize = () => {
      measureFooterContent();
    };

    window.addEventListener("resize", handleResize);
    return () => {
      clearTimeout(timer);
      window.removeEventListener("resize", handleResize);
    };
  }, [measureFooterContent, sectionFilter?.text]);

  useEffect(() => {
    setIsExpanded(false);
  }, [lineLimit, sectionFilter?.text]);

  const sectionContent = sctionContentdata?.filter(
    (findData) => findData?.sectionMasterId === sectionFilter?.id
  );
  const footerOptions = [
    { id: 1, label: translation?.termsAndCondition, path: "/terms-conditions" },
    { id: 2, label: translation?.privacyPolicy, path: "/privacy-policy" },
    { id: 3, label: translation?.contactUs, path: "/contact-us" },
  ];

  const handleData = (footerData) => {
    return sectionContent?.find(
      (findData) => findData.contentSourceType === footerData?.label
    )?.text;
  };

  return (
    <>
      {sectionFilter ? (
        <footer className={`bottom-0 left-0 w-full ${url === "/my-account" ? "" : "mt-8"}`}>
          <div className="footer-container-1 px-4">
            <div className="footer-border">
              <div
                className={`footer-nav py-4 grid ${!isMobileView ? "grid-col-2" : ""
                  } gap-4 md:flex`}
              >
                {footerOptions.map((data) => {
                  const content = handleData(data);
                  return content ? (
                    <Link
                      onClick={() => {
                        if (window.location.pathname !== '/deal') {
                          sessionStorage.setItem("toTop", true);
                        }
                      }}
                      key={data.id}
                      to={data.path}
                      state={{
                        commonComponent: true,
                        Head: data.label,
                        Content: content,
                      }}
                      className="order-1 md:order-none"
                    >
                      {data.label}
                    </Link>
                  ) : null;
                })}
              </div>
            </div>
          </div>
          <div className="footer-container-mid px-4">
            <div className="footer-border">
              <div
                className={`footer-nav pt-4 grid ${!isMobileView ? "grid-col-2" : ""
                  } gap-4 md:flex`}
              >
                <div
                  id="footer-mid-text-content"
                  ref={footerContentRef}
                  className="mid-text footer-mid-text-content mb-2"
                  style={{
                    maxHeight: `${isExpanded ? contentHeight.expanded : contentHeight.collapsed}px`,
                  }}
                  dangerouslySetInnerHTML={{ __html: sectionFilter.text }}
                ></div>
              </div>
              {showReadMore ? (
                <button
                  type="button"
                  className="footer-read-toggle"
                  aria-expanded={isExpanded}
                  aria-controls="footer-mid-text-content"
                  onClick={() => setIsExpanded((prevState) => !prevState)}
                >
                  <span>
                    {isExpanded
                      ? translation?.showLess || "Show Less"
                      : translation?.readMore || "Read More"}
                  </span>
                  <img src={isExpanded ? ArrowUpFooter : ArrowDownFooter} alt="" />
                </button>
              ) : null}
            </div>
          </div>
          <div>
            <div
              className={`footer-container-2 py-4 text-center ${isMobileView ? "px-9" : ""
                } `}
            >
              <span className="footer-span">
                {translation?.copyright} @ {new Date().getFullYear()} {translation?.custCapCopyright}{" "}
              </span>
            </div>
          </div>
        </footer>
      ) : (
        ""
      )}
    </>
  );
};

export default Footer;
